import { render, staticRenderFns } from "./BaseUserLinkWithoutStore.vue?vue&type=template&id=47159eee&scoped=true"
import script from "./BaseUserLinkWithoutStore.vue?vue&type=script&lang=js"
export * from "./BaseUserLinkWithoutStore.vue?vue&type=script&lang=js"
import style0 from "./BaseUserLinkWithoutStore.vue?vue&type=style&index=0&id=47159eee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47159eee",
  null
  
)

export default component.exports